export const createCheckoutSession = async (priceId) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/create-checkout-session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ priceId }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Error desconocido');
    }

    return await response.json();  // ahora se espera { sessionId, redirectUrl }
  } catch (error) {
    console.error('❌ Error al crear la sesión de pago:', error);
    return {};
  }
};
